import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-popin-dialog',
  templateUrl: './popin-dialog.component.html',
  styleUrls: ['./popin-dialog.component.scss'],
})
export class PopinDialogComponent implements OnInit {

  constructor() {}

  @Input() menu: TemplateRef <any>;
  @Input() titre: string;
  @Output() closed = new EventEmitter();

  ngOnInit(): void {
  }

  close_popup() {
    this.closed.emit();
  }

}
